<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    version="1.1"
  >
    <g id="surface1">
      <path
        style=" stroke:none;fill-rule:nonzero;fill:rgb(87, 91, 108);fill-opacity:1;"
        d="M 15.355469 1.429688 C 16.242188 1.429688 17 1.742188 17.628906 2.371094 C 18.257812 3 18.570312 3.757812 18.570312 4.644531 L 18.570312 15.355469 C 18.570312 16.242188 18.257812 17 17.628906 17.628906 C 17 18.257812 16.242188 18.570312 15.355469 18.570312 L 13.257812 18.570312 L 13.257812 11.929688 L 15.480469 11.929688 L 15.816406 9.339844 L 13.257812 9.339844 L 13.257812 7.691406 C 13.257812 7.273438 13.347656 6.960938 13.519531 6.753906 C 13.695312 6.542969 14.035156 6.441406 14.542969 6.441406 L 15.902344 6.429688 L 15.902344 4.117188 C 15.433594 4.050781 14.773438 4.019531 13.917969 4.019531 C 12.90625 4.019531 12.097656 4.316406 11.488281 4.910156 C 10.882812 5.507812 10.582031 6.347656 10.582031 7.433594 L 10.582031 9.339844 L 8.347656 9.339844 L 8.347656 11.929688 L 10.582031 11.929688 L 10.582031 18.570312 L 4.644531 18.570312 C 3.757812 18.570312 3 18.257812 2.371094 17.628906 C 1.742188 17 1.429688 16.242188 1.429688 15.355469 L 1.429688 4.644531 C 1.429688 3.757812 1.742188 3 2.371094 2.371094 C 3 1.742188 3.757812 1.429688 4.644531 1.429688 Z M 15.355469 1.429688 "
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "Facebook"
};
</script>
